import FamilyAlbumModule from './FamilyAlbumModule'
export default FamilyAlbumModule
